import { getDocumentFormActionButtonsV2 } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

/**
 * Get the title for the form dialog based on form mode and active tab
 */
export const getFormTitle = (formMode: FormMode, activeTab: string) => {
  if (formMode !== 'view') {
    return formMode === 'add' ? 'Mới' : 'Sửa';
  }

  switch (activeTab) {
    case 'info':
      return 'Bút toán điều chỉnh giảm công nợ';
    case 'history':
      return 'Lịch sử';
    default:
      return 'Bút toán điều chỉnh giảm công nợ';
  }
};

/**
 * Get the action buttons for the form dialog based on form mode and active tab
 */
export const getFormActionButtons = (
  formMode: FormMode,
  activeTab: string,
  handlers: {
    onAdd?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    onCopy?: () => void;
    handleClose: () => void;
  }
) => {
  return getDocumentFormActionButtonsV2(formMode, activeTab, handlers);
};
